module.exports = __webpack_public_path__ + "img/app-store.a4b11b79.svg";